let initialState =  [{
  name: 'positionName',
  label: '招聘职位',
  type: 'Input',
  baseInfo: [''],
  render: '',
  value: '',
  rules: [{ required: true, message: '请填写完整' }]
}, {
  name: 'wage',
  label: '薪资区间',
  type: 'Input',
  baseInfo: [''],
  render: '',
  value: '',
  rules: [{ required: true, message: '请填写完整' }]
}, {
  name: 'status',
  label: '岗位状态',
  type: 'Select',
  baseInfo: ['正常', '急招'],
  render: '',
  value: '',
  rules: [{ required: true, message: '请填写完整' }]
}, {
  name: 'numbers',
  label: '招聘人数',
  type: 'Input',
  baseInfo: [''],
  render: '',
  value: '',
  rules: [{ required: true, message: '请选择' }]
}, {
  name: 'address',
  label: '工作地点',
  type: 'Input',
  baseInfo: [''],
  render: '',
  value: '',
  rules: [{ required: true, message: '请填写完整' }]
}, {
  name: 'department',
  label: '部门',
  type: 'Input',
  baseInfo: [''],
  render: '',
  value: '',
  rules: [{ required: true, message: '请填写完整' }]
},
{
  name: 'positionContext',
  label: '岗位描述',
  type: 'Input',
  baseInfo: [''],
  render: '',
  value: '',
  rules: [{ required: true, message: '请填写完整' }]
},
{
    name: 'positionRequirements',
    label: '任职要求',
    type: 'Input',
    baseInfo: [''],
    render: '',
    value: '',
    rules: [{ required: true, message: '请填写完整' }]
}
] 

  const backFormData = (state = initialState, action) => {
    //需优化
    switch (action.type) {
      case 'SAVE_FORM':
        return action.data.formList
      default:
        return state;
    }
  }
  export default backFormData
  